import React, {FC, PropsWithChildren} from 'react';
import styled from 'styled-components';

/*
 * Style.
 */

const BannerFooterActionsDiv = styled.div`
  position: relative;
  grid-area: footer;

  margin-top: 1px;
  margin-left: -8px;
  min-width: 0;

  display: flex;
  padding-bottom: 8px;
`;

/*
 * Component.
 */

export const BannerFooterActions: FC<PropsWithChildren<unknown>> = (props) => (
  <BannerFooterActionsDiv>{props.children}</BannerFooterActionsDiv>
);
